module.exports = __webpack_public_path__ + "img/LTS_SARS.653cac4d.gif";